import * as React from 'react';

import './Checkbox.scss';

interface ICheckboxProps {
  name: string;
  value: string;
  checked: boolean;
  onChange: (e: any) => void;
}

class Checkbox extends React.Component<ICheckboxProps, any> {
  public render() {
    return (
      <label className="rp-checkbox no-select">
        <input
          type="checkbox"
          name={this.props.name}
          value={this.props.value}
          checked={this.props.checked}
          onChange={this.props.onChange}
          className="rp-checkbox--input"
        />
        <span
          className={`${
            this.props.checked ? 'rpds-check-box' : 'rpds-check-box-blank'
          } checkbox-icon`}
        />
        <span>{this.props.name}</span>
      </label>
    );
  }
}

export default Checkbox;
